import { checkSlugUnique } from '../utils/api';

const FETCH_SLUG_UNIQUENESS_REQUEST = 'app/FieldProfileSlug/FETCH_SLUG_UNIQUENESS_REQUEST';
const FETCH_SLUG_UNIQUENESS_SUCCESS = 'app/FieldProfileSlug/FETCH_SLUG_UNIQUENESS_SUCCESS';
const FETCH_SLUG_UNIQUENESS_ERROR = 'app/FieldProfileSlug/FETCH_SLUG_UNIQUENESS_ERROR';

// ================ Reducer ================ //

const initialState = {
  fetchInProgress: false,
  fetchError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_SLUG_UNIQUENESS_REQUEST:
      return {
        ...state,
        fetchInProgress: true,
        fetchError: null,
      };
    case FETCH_SLUG_UNIQUENESS_SUCCESS:
      return {
        ...state,
        fetchInProgress: false,
      };
    case FETCH_SLUG_UNIQUENESS_ERROR:
      return {
        ...state,
        fetchInProgress: false,
        fetchError: payload.error,
      };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const fetchSlugUniquenessRequest = () => ({
  type: FETCH_SLUG_UNIQUENESS_REQUEST,
});

export const fetchSlugUniquenessSuccess = (isUnique) => ({
  type: FETCH_SLUG_UNIQUENESS_SUCCESS,
  payload: { isUnique },
});

export const fetchSlugUniquenessError = (error) => ({
  type: FETCH_SLUG_UNIQUENESS_ERROR,
  payload: { error },
});

// ================ Thunks ================ //

export const fetchSlugUniqueness = (slug) => async (dispatch) => {
  dispatch(fetchSlugUniquenessRequest());

  try {
    const response = await checkSlugUnique(slug);
    const { valid } = response;

    dispatch(fetchSlugUniquenessSuccess());
    return valid;
  } catch (error) {
    dispatch(fetchSlugUniquenessError(error));
    return false;
  }
};

// ================ Selectors ================ //

export const validateSlugInProgress = (state) => state.FieldProfileSlug.fetchInProgress;
export const validateSlugError = (state) => state.FieldProfileSlug.fetchError;
